import React from 'react'
import { useHistory } from 'react-router-dom'
import { ArrowRight as ArrowRightIcon } from 'react-feather'
import PropTypes from 'prop-types'
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Typography,
} from '@material-ui/core'

import { BaseDialog } from 'components'

import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import { getTomTicketURL } from 'service/env'
import constants from 'constants/index'
import * as service from 'service'
import theme from 'theme'

const ShowTicketDialog = ({ open, setOpen, setLoading }) => {
  const { HELP_CENTER_TICKET_OPTIONS } = constants.faqs

  const history = useHistory()
  const snackbar = useSnackbar()
  const url = getTomTicketURL()

  const handleRedirect = (id, route) => {
    if (id === 'externalTickets') return handleExternalTicket()
    history.push(route)
  }

  const handleExternalTicket = async () => {
    try {
      setLoading(true)

      const response =
        await service.dponet.tomticketIntermediator.getTomticketToken()

      window.open(`${url}=${response?.data}`, '_blank')
      setOpen(false)
    } catch (error) {
      console.error(error)
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Ocorreu um erro, tente novamente mais tarde!',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <BaseDialog
      open={open}
      setOpen={setOpen}
      title="Ver meus tickets"
      dialogSize="md"
      closeIconButton
      withoutBottomDivider
    >
      <Box
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(2)}
        py={2}
      >
        <Typography color="secondary">
          Selecione a categoria do ticket que deseja consultar
        </Typography>
        <Grid container spacing={2}>
          {HELP_CENTER_TICKET_OPTIONS.map((item, index) => (
            <Grid item key={index} xs={12}>
              <Card>
                <CardActionArea
                  onClick={() => handleRedirect(item.id, item.route())}
                >
                  <CardContent>
                    <Box
                      display="flex"
                      gridGap={theme.spacing(2)}
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Box>
                        <Typography variant="h5" gutterBottom>
                          {item.title}
                        </Typography>
                        <Typography color="secondary">
                          {item.subTitle}
                        </Typography>
                      </Box>
                      <ArrowRightIcon />
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </BaseDialog>
  )
}

ShowTicketDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
}

export default ShowTicketDialog
